import { render, staticRenderFns } from "./AddState.vue?vue&type=template&id=70549366&"
import script from "./AddState.vue?vue&type=script&lang=js&"
export * from "./AddState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports